import React, { useContext, useState } from 'react';

import { Version } from '../../../models/version';

type VersionState = {
  version: Version;
};

type VersionActions = {
  setVersion: (version: Version) => void;
};

export const VersionStateContext = React.createContext<VersionState & VersionActions>({
  version: new Version(''),
  setVersion: () => null,
});

export type VersionProviderProps = {
  initialVersion: Version;
};

export const VersionProvider: React.FC<VersionProviderProps> = ({ children, initialVersion }) => {
  const [version, setVersion] = useState(initialVersion);

  return (
    <VersionStateContext.Provider value={{ version, setVersion }}>
      {children}
    </VersionStateContext.Provider>
  );
};

export const useVersion = () => useContext(VersionStateContext);
